;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  angular.module('app.core').config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.channels', {
      url: '/channels?query&order&direction&type&archived',
      templateUrl: 'channels.html',
      controller: 'Channels',
      controllerAs: '$ctrl',
    })
  }
})()
